import React, { useEffect, useState } from 'react'
import { Form }  from 'react-bootstrap';

function MultiInput({Value,placeholder,hidden,name, OnChange,onKeyDown}) {

    const [focus,setFocus] = useState("");
    const [value,setValue] = useState("");
    const [terms,setTerms] = useState([]);

    const onfocus = ()=> setFocus("focus-multi-input");

    const onblur = () => setFocus("");

    const onChange = (event) => {
        setValue(() => event.target.value);
    }

    const addTerms = (callbck)=>{

        if(terms.findIndex(x=>x === value.trim()) === -1){

            setTerms((prev_terms) => { 

                const aux = [...prev_terms];
                aux.push(value.trim()); 

                return aux; 
    
            });

            setValue(() => "");
            
            // callbck();
        }
    }

    const removeTerm = (term) => {

        setTerms((prev_terms)=>{
            const aux = [...prev_terms];
            const index = aux.indexOf(term);
            if(index > -1){
                aux.splice(index,1);
            }
            return aux;
        })
    }

    useEffect(()=>{
        OnChange({ target : { value : terms } });
        // onKeyDown();
        // eslint-disable-next-line
    },[terms])

    useEffect(()=>{
        console.log(Value)
        // setTerms(() => Value === "" || Value === undefined || Value === null ? [] : Value);
    },[Value])

  return (<>
      <label htmlFor={name} hidden={hidden} className={`form-control border-1 p-0 ${focus}`}>


        <ul className='m-0 p-0' style={{listStyle:"none"}}>
            {
                terms.map((term,index) =>{
                    return(
                        <li 
                            key={`term_${index}`} 
                            style={{float:"left"}}
                            className='d-table p-1 m-1 border-1 shadow-sm bg-info rounded'
                        >
                            {term}
                            <button type="button" className="btn-close ms-1" aria-label="Close" onClick={()=>removeTerm(term)}></button>
                        </li>
                    )
                })
            }
        </ul>

        <Form.Control 
            // ref             = { inputmask }
            id          = {name}
            name        = {name}
            className   = { `border-0`}
            key         = { 'input_search'}
            hidden      = { false }
            type        = { 'text' }  
            onChange    = { onChange  }  
            placeholder =   { placeholder }
            value       =   { value } 
            onFocus     =   { onfocus }
            onBlur      =   { onblur }
            onKeyDown   = { (e) => { 
              
                if(e.target.value !== ""){
                    if(e.code === "Enter" || e.code === "NumpadEnter") 
                    {
                        addTerms(()=>{
                            onKeyDown(e);
                        });
                        
                    } 
                }
            }}
        />
    </label>
  </>)
}

export default MultiInput